import { Space, Col, Row, Form } from 'antd';
import { useOrderEditContext } from './OrderEditContext';
import OrderGeneralCard from './OrderGeneralCard';
import OrderLineItemsCard from './OrderLineItemsCard';
import OrderSummaryCard from './OrderSummaryCard';
import ProductPickerPanel from './ProductPickerPanel';

const OrderEditDesktop = () => {
    const { form, onFinish, onFinishFailed } = useOrderEditContext();

    return (
        <Form
            name="basic"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout='vertical'
        >
            <Space direction="vertical" size={16} style={{ width: "100%" }}>
                <OrderGeneralCard />

                <Row gutter={16}>
                    <Col span={16}>
                        <OrderLineItemsCard />
                        <ProductPickerPanel />
                    </Col>
                    <Col span={8}>
                        <OrderSummaryCard />
                    </Col>
                </Row>
            </Space>
        </Form>
    );
};

export default OrderEditDesktop;
